import { humanizeEventDefinition } from 'common/helpers/humanize';

import { widgetTypes } from './constants/eventAnalytics.constants';

// eventAnalytics.actions stores raw enum identifiers; these map them to display labels at
// render time so a language switch relabels the charts without refetching.
const AXIS_I18N_KEYS = {
  event_type: 'activity.filters.eventType',
  duration: 'eventAnalytics.charts.axes.duration',
  count: 'eventAnalytics.charts.axes.count',
  events: 'eventAnalytics.charts.axes.events'
};

const translateHeaderRow = (t, row) => (Array.isArray(row)
  ? row.map(cell => (AXIS_I18N_KEYS[cell] ? t(AXIS_I18N_KEYS[cell]) : cell))
  : row);

// Header row plus one localized event-type label per data row.
const translateEventTypeRows = (t, rows) => (Array.isArray(rows) && rows.length ? [
  translateHeaderRow(t, rows[0]),
  ...rows.slice(1).map(([eventType, ...rest]) => [humanizeEventDefinition(eventType, t), ...rest])
] : rows);

const translateStateLabels = (t, rows) => (Array.isArray(rows) ? rows.map(d => ({
  ...d,
  label: t(`widgetLibrary.chartLabels.${d.label}`, { defaultValue: d.label })
})) : rows);

const translateHistogramRows = (t, rows) => (Array.isArray(rows) && rows.length
  ? [translateHeaderRow(t, rows[0]), ...rows.slice(1)]
  : rows);

/**
 * Localizes one widget's dataset. Each `widgetTypes` value has its own row shape —
 * donut rows are `{ value, label }` objects, bar and histogram rows are arrays — so the
 * translator must be picked by widget type and never applied across shapes.
 */
export const translateChartData = (widgetType, t, data) => {
  switch (widgetType) {
    case widgetTypes.DONUT_CHART:
      return translateStateLabels(t, data);
    case widgetTypes.BAR_CHART:
      return translateEventTypeRows(t, data);
    case widgetTypes.HISTOGRAM:
      return translateHistogramRows(t, data);
    default:
      return data;
  }
};
